module.exports = __webpack_public_path__ + "static/media/violinplay_functioncalling.1131e4ad.wav";